import MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry from "../../../sections/DirectiveEntry/entries/DiagnosticEntry";

const DiagnosticEntryOnGoingEstablishmentChoice = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry />
    </>
  );
}

export default DiagnosticEntryOnGoingEstablishmentChoice;
